var AnimakitExpander = require('./lib/AnimakitExpander');

AnimakitExpander.displayName = 'AnimakitExpander';

module.exports = AnimakitExpander;
